
import {View} from 'backbone';
import template from 'common-views/test-email-confirmation.ejs';
import constants from 'Constants.js';
import $ from 'jquery';
import util from 'util/Util.js';

class TestEmailConfirmationModalView extends View {
    initialize(opts){
        super.initialize(opts);
        $('body').append(this.$el);
    }

    render(){
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();

            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 'auto',
                width: 400,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Ok',
                        'class':'btn-select-item',
                        disabled:false,
                        click: () => {
                            resolve('OK');
                            this.closeModal();
                        }
                    }
                ],
                open: () => {
                    $(constants.DIALOG_ID).css('overflow','hidden');
                },
                close: () => {
                    $(constants.DIALOG_ID).css('overflow','scroll');
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        });
    }


    closeModal(){
        $( constants.DIALOG_ID ).dialog("destroy").remove();
    }
}

export default TestEmailConfirmationModalView;